// extracted by mini-css-extract-plugin
module.exports = {"modal-scroll":"Loading_modal-scroll__GG4R_","container":"Loading_container__iMjrJ","loading":"Loading_loading___57U5"};